import * as actionTypes from './actionTypes';
import axios from 'axios';

import seatMapResponse from '../../assets/json/seatMap.json';

export const setSeats = (seatsData) => {
    const parsedSeatsData = seatsData;
    return {
        type: actionTypes.SET_SEATS,
        seats: parsedSeatsData
    }
}

export const getSeatsFailed = () => {
    return {
        type: actionTypes.GET_SEATS_FAILED
    }
}

export const setSeatsLoading = () => {
    return {
        type: actionTypes.SET_SEATS_LOADING
    }
}

export const getSeats = (seatsParams) => {
    console.log(seatsParams);
    return dispatch => {
        dispatch(setSeatsLoading());
        dispatch(setSeats(seatMapResponse));
        // axios.get('https://secure.yatra.com/air-service/seatMapResponse', {
        //     params: seatsParams
        // }).then(response => {
        //     dispatch(setSeats(response.data));
        // }).catch(error => {
        //     dispatch(getSeatsFailed(error));
        // })
    }
}

export const hoverSeat = (seatNo) => {
    return {
        type: actionTypes.HOVER_SEAT,
        val: seatNo
    }
}

export const seatClicked = () => {
    return {
        type: actionTypes.SEAT_CLICKED
    }
}

export const leaveSeat = () => {
    return {
        type: actionTypes.LEAVE_SEAT
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/seats.js